import React from 'react';
import AppRoutes from 'routes/app.routes';

const App: React.FC = () => {
   return <AppRoutes />;
};

export default App;
